import type { PlanDto } from "./types";

/** «Сделать» доступна для черновика, когда каждый опасный шаг подтверждён отдельно (п. 4 спеки). */
export function canExecute(plan: PlanDto, confirmed: number[]): boolean {
  return (
    plan.status === "DRAFT" &&
    plan.steps.every((s) => !s.dangerous || confirmed.includes(s.index))
  );
}
